module.exports = __webpack_public_path__ + "static/media/Logo-SACMEX.47e0c915.jpg";